var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcToolbarItem MatcToolbarGridFull",on:{"mousedown":function($event){$event.stopPropagation();}}},[_c('DesignTokenPreview',{attrs:{"designtoken":_vm.designtoken}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }